import React from 'react';
import { Box, TextField, MenuItem } from '@mui/material';

function FiltrosGraficasMaquina({ fechaInicio, setFechaInicio, fechaFin, setFechaFin, maquina, setMaquina, maquinas }) {
  return (
    <Box sx={{ display: 'flex', gap: 2, mb: 2, flexWrap: 'wrap' }}>
      <TextField
        select
        label="Máquina"
        value={maquina}
        onChange={e => setMaquina(e.target.value)}
        sx={{ minWidth: 180 }}
      >
        <MenuItem value=""><em>Todas las máquinas</em></MenuItem>
        {maquinas.length === 0 ? (
          <MenuItem value="" disabled><em>No hay máquinas disponibles</em></MenuItem>
        ) : (
          maquinas.map(m => (
            <MenuItem key={m} value={m}>{m}</MenuItem>
          ))
        )}
      </TextField>
      <TextField
        label="Fecha inicio"
        type="date"
        value={fechaInicio}
        onChange={e => setFechaInicio(e.target.value)}
        InputLabelProps={{ shrink: true }}
      />
      <TextField
        label="Fecha fin"
        type="date"
        value={fechaFin}
        onChange={e => setFechaFin(e.target.value)}
        InputLabelProps={{ shrink: true }}
      />
    </Box>
  );
}

export default FiltrosGraficasMaquina;
